
import { Component, Prop } from 'vue-property-decorator'
import Mixin from '../helpers/mixin'

@Component({
  template: `
  <div class='list'>
    <a
      v-for="item in itemsToShow"
      class="block block--product"
      :class="{'has-button-text': item.buttonText !== ''}"
      :href="item.url"
      :title="title(item)"
    >
      <div class='relative'>
        <template v-if="imageUrl(item) && imageUrl(item) !== ''">
          <img :src='imageUrl(item) + imageQuery' alt='imageAlt(item)' />
        </template>
        <template v-else-if="defaultImage && defaultImage !== ''">
          <img :src='defaultImage + imageQuery' alt='imageAlt(item)'>
        </template>
        <template v-else>
          <img />
        </template>
      </div>

      <div class='bottom product-block__bottom'>
        <h2 v-if="categoryOverview" class='title'>{{ title(item) }}</h2>
        <h3 v-else class='title'>{{ title(item) }}</h3>

        <div class='button-text product-block__button-text'>
          {{ title(item) }}
          <i class='icons8-chevron-right'></i>
        </div>
      </div>
    </a>
  </div>
  `
})
export default class BlockItems extends Mixin {
  @Prop() items: any
  @Prop() defaultImage: string
  @Prop() categoryOverview: boolean

  itemsToShow = []

  imageQuery = '?width=250&height=250&mode=Min&format=webp'

  created() {
    this.itemsToShow = this.items.toSorted((a: any, b: any) => b.priority - a.priority)
  }

  title(item: any): string {
    if (item.heroTitle && item.heroTitle != '') {
      return item.heroTitle
    } else if (item.title !== '') {
      return item.title
    }
    return ''
  }

  imageUrl(item: any): string {
    if (item.heroImage && item.heroImage != '') {
      return item.heroImage
    }
    return ''
  }

  imageAlt(item: any): string {
    if (item.heroImageAltTag && item.heroImageAltTag != '') {
      return item.heroImageAltTag
    } else if (item.heroImage !== '') {
      return item.heroImage
    }
    return ''
  }
}
